import SEOHead from '../components/SEOHead';

export default function PrivacyPolicy() {
  return (
    <main data-testid="privacy-policy-page">
      <SEOHead
        title="Privacy Policy | Trademark Legal Forum"
        description="Read Trademark Legal Forum's Privacy Policy. Learn how we collect, use, and protect your personal information when using our trademark and IP services."
      />
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0D1729] to-[#0A1128]" />
        <div className="container mx-auto px-6 md:px-12 relative z-10">
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#D4AF37] mb-4 font-['Outfit']">Legal</p>
          <h1 className="text-4xl sm:text-5xl font-bold text-white font-['Outfit'] tracking-tight">Privacy Policy</h1>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-[#0A1128]">
        <div className="container mx-auto px-6 md:px-12 max-w-4xl">
          <div className="prose prose-invert max-w-none space-y-8">
            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">1. Information We Collect</h2>
              <p className="text-[#A0AABF] leading-relaxed mb-3">We collect personal information that you voluntarily provide when using our services, including but not limited to: your name, email address, phone number, mailing address, and any information related to your trademark application or business needs.</p>
              <p className="text-[#A0AABF] leading-relaxed">We may also collect technical information automatically, such as your IP address, browser type, operating system, referring URLs, and browsing patterns on our website through cookies and similar technologies.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">2. How We Use Your Information</h2>
              <p className="text-[#A0AABF] leading-relaxed mb-3">We use the information we collect for the following purposes:</p>
              <ul className="list-disc pl-6 space-y-2 text-[#A0AABF]">
                <li>To provide, maintain, and improve our trademark registration and related services</li>
                <li>To process your applications and communicate with you about their status</li>
                <li>To respond to your inquiries and provide customer support</li>
                <li>To send you relevant updates about your trademark filings and service notifications</li>
                <li>To comply with legal obligations and protect our legal rights</li>
                <li>To analyze website usage and improve our user experience</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">3. Information Sharing</h2>
              <p className="text-[#A0AABF] leading-relaxed">We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our business, such as payment processors and filing services, provided they agree to keep your information confidential. We may also disclose your information when required by law or to protect our rights.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">4. Data Security</h2>
              <p className="text-[#A0AABF] leading-relaxed">We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is completely secure, and we cannot guarantee absolute security.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">5. Cookies</h2>
              <p className="text-[#A0AABF] leading-relaxed">Our website uses cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors come from. You can control cookie settings through your browser preferences.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">6. Third-Party Links</h2>
              <p className="text-[#A0AABF] leading-relaxed">Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to read the privacy policy of every website you visit.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">7. Your Rights</h2>
              <p className="text-[#A0AABF] leading-relaxed">You have the right to access, correct, or delete your personal information. You may also opt out of marketing communications at any time. To exercise these rights, please contact us using the information provided on our Contact page.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">8. Changes to This Policy</h2>
              <p className="text-[#A0AABF] leading-relaxed">We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated revision date. Your continued use of our services after any changes constitutes your acceptance of the revised policy.</p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-white font-['Outfit'] mb-4">9. Contact Us</h2>
              <p className="text-[#A0AABF] leading-relaxed">If you have any questions about this Privacy Policy, please contact us through our Contact page or email us at info@trademarklegalforum.com.</p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
